import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { API_URL } from '../../../settings/local_settings';
import { APIClient } from '../../../utils/APIClient';
import { Spinner } from '../../Spinner';
import { withTranslation } from 'react-i18next';

const MAX_WIDTH = 1200;
const JPEG_QUALITY = 0.7;

function resizeAndCompress(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
                let { width, height } = img;
                if (width > MAX_WIDTH) {
                    height = Math.round(height * (MAX_WIDTH / width));
                    width = MAX_WIDTH;
                }
                const canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);
                resolve(canvas.toDataURL('image/jpeg', JPEG_QUALITY));
            };
            img.onerror = reject;
            img.src = e.target.result;
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

class NotifyPaymentModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            sending: false,
            sent: false,
            comments: '',
            attachmentUrl: '',
            pastedImage: null
        };
        this.toggle = this.toggle.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePaste = this.handlePaste.bind(this);
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen,
            sending: false,
            sent: false,
            comments: '',
            attachmentUrl: '',
            pastedImage: null
        });
    }

    async handlePaste(e) {
        const items = e.clipboardData && e.clipboardData.items;
        if (!items) return;

        for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf('image') !== -1) {
                e.preventDefault();
                const file = items[i].getAsFile();
                try {
                    const dataUri = await resizeAndCompress(file);
                    this.setState({ pastedImage: dataUri, attachmentUrl: '' });
                } catch (err) {
                    console.error('Error processing pasted image:', err);
                }
                return;
            }
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setState({ sending: true });

        const attachmentValue = this.state.pastedImage || this.state.attachmentUrl || undefined;

        new APIClient(API_URL + 'agency/subscription/notify-payment/')
            .call('POST', {
                liquidation_id: this.props.liquidationId,
                liquidation_month: this.props.liquidationMonth,
                comments: this.state.comments,
                attachment_url: attachmentValue
            })
            .then((data) => {
                if (data.status === 'OK') {
                    this.setState({ sending: false, sent: true });
                } else {
                    this.setState({ sending: false });
                    alert(data.error_message || 'Error');
                }
            });
    }

    render() {
        const { t, liquidationMonth } = this.props;
        const { isOpen, sending, sent, pastedImage } = this.state;

        return (
            <>
                <button
                    className="btn -negative"
                    onClick={this.toggle}
                    style={{
                        fontSize: '0.7em',
                        padding: '0.2em 0.6em',
                        whiteSpace: 'nowrap'
                    }}
                >
                    {t('agency_subscription.notify_payment')}
                </button>
                <Modal isOpen={isOpen} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>
                        {t('agency_subscription.notify_payment_title')} - {liquidationMonth}
                    </ModalHeader>
                    {sent ? (
                        <>
                            <ModalBody>
                                <div style={{ textAlign: 'center', padding: '1rem' }}>
                                    <div style={{ fontSize: '2rem', marginBottom: '0.5rem', color: '#198754' }}>&#10003;</div>
                                    <p>{t('agency_subscription.payment_notification_sent')}</p>
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="secondary" onClick={this.toggle}>{t('agency_subscription.close')}</Button>
                            </ModalFooter>
                        </>
                    ) : (
                        <form onSubmit={this.handleSubmit}>
                            <ModalBody>
                                <div className="modal-section">
                                    <p style={{ color: '#6c757d', fontSize: '0.9em', marginBottom: '1.2rem' }}>
                                        {t('agency_subscription.review_notice')}
                                    </p>
                                    <div className="form-row" style={{ marginBottom: '1rem' }}>
                                        <label>{t('agency_subscription.attachment_label')}</label>
                                        {pastedImage ? (
                                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                                <img
                                                    src={pastedImage}
                                                    alt="comprobante"
                                                    style={{ maxWidth: '100%', maxHeight: '200px', borderRadius: '4px', border: '1px solid #dee2e6' }}
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() => this.setState({ pastedImage: null })}
                                                    style={{
                                                        position: 'absolute',
                                                        top: '-8px',
                                                        right: '-8px',
                                                        background: '#dc3545',
                                                        color: '#fff',
                                                        border: 'none',
                                                        borderRadius: '50%',
                                                        width: '24px',
                                                        height: '24px',
                                                        cursor: 'pointer',
                                                        fontSize: '14px',
                                                        lineHeight: '24px',
                                                        padding: 0
                                                    }}
                                                >
                                                    &times;
                                                </button>
                                            </div>
                                        ) : (
                                            <div
                                                onPaste={this.handlePaste}
                                                tabIndex="0"
                                                style={{
                                                    border: '2px dashed #dee2e6',
                                                    borderRadius: '4px',
                                                    padding: '1.5rem',
                                                    textAlign: 'center',
                                                    color: '#6c757d',
                                                    cursor: 'text',
                                                    outline: 'none'
                                                }}
                                                onFocus={(e) => e.target.style.borderColor = '#FF470F'}
                                                onBlur={(e) => e.target.style.borderColor = '#dee2e6'}
                                            >
                                                {t('agency_subscription.paste_image_here')}
                                            </div>
                                        )}
                                    </div>
                                    {!pastedImage && (
                                        <div className="form-row" style={{ marginBottom: '1rem' }}>
                                            <label style={{ fontSize: '0.85em', color: '#6c757d' }}>
                                                {t('agency_subscription.or_paste_url')}
                                            </label>
                                            <input
                                                type="url"
                                                className="form-control"
                                                value={this.state.attachmentUrl}
                                                onChange={(e) => this.setState({ attachmentUrl: e.target.value })}
                                                placeholder={t('agency_subscription.attachment_url_placeholder')}
                                            />
                                        </div>
                                    )}
                                    <div className="form-row">
                                        <label>{t('agency_subscription.comments')}</label>
                                        <textarea
                                            className="form-control"
                                            rows="5"
                                            style={{ height: 'auto' }}
                                            value={this.state.comments}
                                            onChange={(e) => this.setState({ comments: e.target.value })}
                                            placeholder={t('agency_subscription.payment_comments_placeholder')}
                                        />
                                    </div>
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="secondary" onClick={this.toggle}>{t('agency_subscription.cancel_action')}</Button>
                                {sending
                                    ? <Spinner color="positive small" />
                                    : <Button color="primary" type="submit">{t('agency_subscription.send_notification')}</Button>
                                }
                            </ModalFooter>
                        </form>
                    )}
                </Modal>
            </>
        );
    }
}

export default withTranslation()(NotifyPaymentModal);
